import i18n from 'i18next';
import languageDetector from 'i18next-browser-languagedetector';
// import Pseudo from 'i18next-pseudo';
import { initReactI18next } from 'react-i18next';
import intervalPlural from 'i18next-intervalplural-postprocessor';
import resources from './locales';
import { DEBUG } from '../../ReduxStorage/location/constants';
import { OL_LANGUAGE_KEY } from './constants';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(languageDetector)

  // note(xun): language detector is not compatible with pseudo localisation
  // hence we just need to enable either one during the development
  // see issue: https://github.com/MattBoatman/i18next-pseudo/issues/4

  // enable pseudo localisation
  // learn more: https://github.com/MattBoatman/i18next-pseudo
  // .use(
  //   new Pseudo({
  //     wrapped: true,
  //   })
  // )

  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  .use(intervalPlural)

  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    preload: ['en'],
    debug: DEBUG,

    ns: ['common'], // common.json should contain all navigation related strings
    defaultNS: 'common',
    fallbackNS: ['common'],

    // turn on pseudolocalisation
    // postProcess: ['pseudo'],

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    react: {
      useSuspense: false,
    },

    resources,

    // turn on the browser detection
    // possible value for order - 'querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'
    // can be customized to use own detection functionality, refer https://github.com/i18next/i18next-browser-languageDetector
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: OL_LANGUAGE_KEY,
    },
  });

export const i18next = i18n;
